export const siteSettings = {
  name: "Finex Exchange",
  link: "https://finexchange.live",
  email: "support@finexchange.live",
  appLink: "https://app.finexchange.live",
};
